module.exports = __webpack_public_path__ + "static/media/body_shape_icon.20e520a5.svg";